import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=4bb205af&scoped=true&"
import script from "./Topbar.vue?vue&type=script&lang=js&"
export * from "./Topbar.vue?vue&type=script&lang=js&"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=4bb205af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb205af",
  null
  
)

export default component.exports